import notification from '@iso/components/feedback/Notification';

// For the sagas that run from pages without an invoice list on screen (the booking forms, the client
// page): a refused or failed write there used to vanish into a console.log. The invoice list and the
// edit page show the same messages through the store (errorMessage) instead.
export function notifyInvoiceError(message) {
  notification('error', 'Invoice not saved', message, 10);
}
